import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetTrialBalanceLineItemReportExportProps {
  type: string;
  id: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTrialBalanceLineItemReportExport = async (type: string, id: string, filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/${type}/${id}/line-items/export?${new URLSearchParams(filter).toString()}`, {
    responseType: "blob",
  });

const useGetTrialBalanceLineItemReportExport = ({
  type,
  id,
  filter,
  queryParams,
}: UseGetTrialBalanceLineItemReportExportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["trial-balance-line-item-report-export", id],
    queryFn: () => getTrialBalanceLineItemReportExport(type, id, filter),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetTrialBalanceLineItemReportExport;
